
import { mapActions, mapMutations } from 'vuex'
export default {
  name: 'IndexPage',
  auth: false,
  async fetch() {
    const res = await this.getPropertyList()
    if (res) {
      this.propertyList = res.data
      console.log(this.propertyList)
    }
  },
  data: () => ({
    items: ['Foo', 'Bar', 'Fizz', 'Buzz'],
    expand: false,
    showSchedule: false,
    showMap: false,
    areaSelected: null,
    searchKeyword: null,
    propertyList: [
      // {
      //   media: [],
      //   propertyType: 'Condo',
      //   beds: 1,
      //   baths: 1,
      //   unitSquareInMetres: 100,
      // },
      // {
      //   media: [],
      //   propertyType: 'Condo',
      //   beds: 1,
      //   baths: 1,
      //   unitSquareInMetres: 100,
      // },
      // {
      //   media: [],
      //   propertyType: 'Condo',
      //   beds: 1,
      //   baths: 1,
      //   unitSquareInMetres: 100,
      // },
      // {
      //   media: [],
      //   propertyType: 'Condo',
      //   beds: 1,
      //   baths: 1,
      //   unitSquareInMetres: 100,
      // },
      // {
      //   media: [],
      //   propertyType: 'Condo',
      //   beds: 1,
      //   baths: 1,
      //   unitSquareInMetres: 100,
      // },
      // {
      //   media: [],
      //   propertyType: 'Condo',
      //   beds: 1,
      //   baths: 1,
      //   unitSquareInMetres: 100,
      // },
      // {
      //   media: [],
      //   propertyType: 'Condo',
      //   beds: 1,
      //   baths: 1,
      //   unitSquareInMetres: 100,
      // },
      // {
      //   media: [],
      //   propertyType: 'Condo',
      //   beds: 1,
      //   baths: 1,
      //   unitSquareInMetres: 100,
      // },
    ],
    showdemodialog: false,
    showdemodialogTh: false,
  }),
  computed: {
    disabledMenus() {
      if (process.browser) {
        if (
          window.location.origin === 'https://properlly.co.th' ||
          window.location.origin === 'https://www.properlly.co.th') {
          this.showdemodialogTh = true
          this.$i18n.setLocale('th')
         
        } else {
          this.showdemodialogTh = false
        }
        if (window.location.origin === 'https://properlly.com' ||
          window.location.origin === 'https://www.properlly.com' ||
          window.location.origin === 'https://properlly.co.th' ||
          window.location.origin === 'https://www.properlly.co.th') {
          this.showdemodialog = true
        } else {
          this.showdemodialog = false
        }
        return (
          window.location.origin === 'https://properlly.com' ||
          window.location.origin === 'https://www.properlly.com' ||
          window.location.origin === 'https://properlly.co.th' ||
          window.location.origin === 'https://www.properlly.co.th'
        )
      } else {
        this.showdemodialog = false
        this.showdemodialogTh = false
        return false
      }
    }
  },
  mounted() {
    if (
      window.location.origin === 'https://properlly.co.th' ||
      window.location.origin === 'https://www.properlly.co.th') {
      this.showdemodialogTh = true
    } else {
      this.showdemodialogTh = false
    }
    if (window.location.origin === 'https://properlly.com' ||
      window.location.origin === 'https://www.properlly.com' ||
      window.location.origin === 'https://properlly.co.th' ||
      window.location.origin === 'https://www.properlly.co.th') {
      this.showdemodialog = true
    } else {
      this.showdemodialog = false
    }
  },
  methods: {
    ...mapMutations('config/site', ['setScheduleShow']),
    ...mapMutations('home', ['setSearchParams']),
    ...mapActions('home', ['getPropertyList']),
    search() { },
    mapAreaSelected(ev) {
      console.log('mapAreaSelected', ev)
      this.areaSelected = ev
      this.showMap = false
      this.gotoSearch()
    },
    gotoSearch() {
      let latlng = { lat: null, lng: null }
      switch (this.areaSelected) {
        case 'Central':
          latlng = { lat: 13.7563, lng: 100.5018 }
          break
        case 'North-East':
          latlng = { lat: 16.4325, lng: 102.8233 }
          break
        case 'North':
          latlng = { lat: 18.1529, lng: 100.1426 }
          break
        case 'East':
          latlng = { lat: 13.3613, lng: 101.0443 }
          break
        case 'South':
          latlng = { lat: 9.1412, lng: 99.325 }
          break
        case 'West':
          latlng = { lat: 15.7047, lng: 100.1372 }
          break
      }
      this.$router.push(
        `/search?keyword=${this.searchKeyword ? this.searchKeyword : ''}&area=${this.areaSelected
        }&lat=${latlng.lat}&lng=${latlng.lng}`
      )
    },
  },
  head() {
    return {
      title: 'Properlly',
      meta: [
        // Facebook
        {
          hid: 'og:title',
          property: 'og:title',
          content: 'Properlly',
        },
        {
          hid: 'og:description',
          property: 'og:description',
          content: `${this.$t('Properlly')}`,
        },
        {
          hid: 'og:image',
          property: 'og:image',
          content: '',
        },
        {
          hid: 'og:url',
          property: 'og:url',
          content: `${this.origin}${this.$route.fullPath}`,
        },
        // Twitter
        {
          hid: 'twitter:title',
          property: 'twitter:title',
          content: 'Properlly',
        },
        {
          hid: 'twitter:description',
          property: 'twitter:description',
          content: 'Properlly',
        },
        {
          hid: 'twitter:image',
          property: 'twitter:image',
          content: '',
        },
        {
          hid: 'twitter:url',
          property: 'twitter:url',
          content: `${this.origin}${this.$route.fullPath}`,
        },
      ],
    }
  },
}
